import React from 'react'
import { defineMessages, FormattedHTMLMessage, injectIntl } from 'react-intl'
import Select from 'react-select'
import { dispatchPushURL } from '../store/ui/actions'
import { connect } from 'react-redux'
import { byProductId } from '../store/products/reducers'
import {
    getAlternativeFieldValues,
    getAlternativeValues,
    getCurrentAlternatives,
    getCurrentAlternativesTree, getModifiedAlternativeFieldValues
} from '../store/crossSelling/reducers'

const msg = defineMessages({
    PREVIOUS_CHOICE_NOT_AVAILABLE: {
        id: 'previous_choice_not_available',
        description: 'previous_choice_not_available',
        defaultMessage: '<b>Selection updated:</b> Previous choice is not available for this combination.',
    }
})

const mapDispatchToProps = dispatch => {
    return {
        redirect: url => {
            dispatch(dispatchPushURL(url))
        },
        updateAlternativeFields: (values) => dispatch({'type':'FETCH_PRODUCT_UPDATE_ALTERNATIVE_FIELD_VALUES', alternativeFieldValues: values}),
        updateModifiedAlternativeFields: (values) => dispatch({'type':'MARK_MODIFIED_ALTERNATIVE_FIELD_VALUES', modifiedAlternativeFieldValues: values})
    }
}

const mapStateToProps = (state, props) => {
    const alternativesValues = getAlternativeValues(state)
    return {
        product: byProductId(state, props.productId),
        alternativesTree: getCurrentAlternativesTree(state),
        rawAlternatives: getCurrentAlternatives(state),
        alternatives: alternativesValues && alternativesValues[props.field],
        alternativeValues: alternativesValues,
        alternativeFieldValues: getAlternativeFieldValues(state),
        modifiedAlternativeFieldValues: getModifiedAlternativeFieldValues(state),
    }
}

class FiltersProduct extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            classActiveBool: false,
            options: [],
            selected: null
        }
        const fieldValues = this.props.alternativeFieldValues

        fieldValues[this.props.field] = props.value
        this.props.updateAlternativeFields(fieldValues)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.alternatives !== prevProps.alternatives) {
            const alternativeValues = Object.keys(this.props.alternatives)
            const options = alternativeValues.map(alternative => {
                let label = alternative
                if (this.props.field === 'zaddon') {
                    label = label === 'MAL' ? 'yes' : 'no'
                }
                return {
                    value: alternative,
                    label: this.props.translateValue ? this.props.intl.formatMessage({ id: label }) : label
                }
            })

            let selected = null

            if (this.props.value && this.props.alternatives[this.props.value]) {
                let label = this.props.value
                if (this.props.field === 'zaddon') {
                    label = label === 'MAL' ? 'yes' : 'no'
                }

                selected = {
                    value: this.props.alternatives[this.props.value],
                    label: this.props.translateValue ? this.props.intl.formatMessage({ id: label }) : label
                }
            }
            this.setState({options: options, selected: selected})
        }
    }

    updateAlternativeValues = value => {
        const fieldValues = Object.assign({}, this.props.alternativeFieldValues)
        const modifiedFieldValues = Object.assign({}, this.props.modifiedAlternativeFieldValues)
        fieldValues[this.props.field] = value


        const otherFields = this.getOtherFieds()
        const fieldAlternatives = {}

        otherFields.forEach((_field, i) => {
            const rawAlternatives = this.props.rawAlternatives[this.props.field][this.state.selected.value][_field]
            fieldAlternatives[_field] = rawAlternatives
            if (!rawAlternatives[fieldValues[_field]]) {
                fieldValues[_field] = Object.keys(rawAlternatives)[0]
                modifiedFieldValues[_field] = true
            } else {
                modifiedFieldValues[_field] = false
            }
            modifiedFieldValues[this.props.field] = false
        })

        const {alternativesTree, redirect, outlet, intl} = this.props
        const sku = alternativesTree[fieldValues.thickness]
            && alternativesTree[fieldValues.thickness][fieldValues.finish]
            && alternativesTree[fieldValues.thickness][fieldValues.finish][fieldValues.format]
            && alternativesTree[fieldValues.thickness][fieldValues.finish][fieldValues.format][fieldValues.zaddon]

        this.props.updateAlternativeFields(fieldValues)
        this.props.updateModifiedAlternativeFields(modifiedFieldValues)

        if (sku) {
            redirect(
                intl
                    .formatMessage({ id: 'ROUTE_PRODUCT_DETAIL' })
                    .replace(':id', sku)
                    .replace(':outlet?', outlet ? 'outlet' : '')
            )
        }
    }

    getOtherFieds = () => {
        const fields = ['thickness', 'format', 'finish', 'zaddon']
        const index = fields.indexOf(this.props.field)
        fields.splice(index, 1)
        return fields
    }

    render() {
        if (!this.props.rawAlternatives) return null

        return (
            <div>
                <span className="select-heading-product">{this.props.selectHeading}</span>
                <div>
                    <Select
                        isSearchable={false}
                        onChange={selectOption => {
                            const oldValue = this.state.selected && this.state.selected.value
                            if (selectOption.value !== oldValue) {
                                this.setState({ selected: selectOption }, () => this.updateAlternativeValues(selectOption.value))
                            }
                        }}
                        value={this.state.selected}
                        options={this.state.options}
                        clearable={false}
                        className="select_filter_products"
                    />
                    {
                        !!this.props.modifiedAlternativeFieldValues[this.props.field] &&
                        <div className="product-detail-filter-alert">
                            <i className="fal fa-exclamation-triangle"/>&nbsp;<FormattedHTMLMessage {...msg.PREVIOUS_CHOICE_NOT_AVAILABLE} />
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(FiltersProduct))
